// // Contact.js
// import React, { useEffect } from "react";
// import "./Contact.css";
// import AOS from "aos";
// import "aos/dist/aos.css";
// import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

// const MAP_ADDRESS =
//   "Office no. 213-214, Second Floor, City Point, Boat Club Rd, Bund Garden, Sangamvadi, Pune, Maharashtra 411001";

// const Contact = () => {
//   useEffect(() => {
//     AOS.init({ duration: 1000, once: true });
//   }, []);

//   // Simple embed URL using your address (works without API key)
//   const mapEmbedSrc = `https://www.google.com/maps?q=${encodeURIComponent(
//     MAP_ADDRESS
//   )}&output=embed`;

//   return (
//     <div className="contact-section">
//       {/* soft animated background */}
//       <div className="c-blob c-blob-1" aria-hidden="true" />
//       <div className="c-blob c-blob-2" aria-hidden="true" />

//       <h2 className="contact-title" data-aos="fade-down">
//         Get in Touch
//       </h2>
//       <p className="contact-subtitle" data-aos="fade-up">
//         We'd love to hear from you. Reach out with your questions or ideas!
//       </p>

//       <div className="contact-grid">
//         {/* Phone */}
//         <div className="contact-card" data-aos="fade-up" data-aos-delay="100">
//           <FaPhoneAlt className="contact-icon" />
//           <h3>Phone</h3>
//           <p className="contact-value">
//             <a
//               className="contact-link"
//               href="tel:+917276445893"
//               aria-label="Call Aazira Solutions at +91 7276445893"
//             >
//               +91 7276445893
//             </a>
//           </p>
//         </div>

//         {/* Email */}
//         <div className="contact-card" data-aos="fade-up" data-aos-delay="200">
//           <FaEnvelope className="contact-icon" />
//           <h3>Email</h3>
//           <p className="contact-value">
//             <a
//               className="contact-link"
//               href="mailto:info@aaziratechnologies.com?subject=Inquiry%20from%20Website"
//               aria-label="Email contact at Aazira Solutions"
//             >
//               info@aaziratechnologies.com
//             </a>
//           </p>
//         </div>

//         {/* Address */}
//         <div className="contact-card" data-aos="fade-up" data-aos-delay="300">
//           <FaMapMarkerAlt className="contact-icon" />
//           <h3>Address</h3>
//           <p className="contact-value">
//             <a
//               className="contact-link"
//               href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
//                 MAP_ADDRESS
//               )}`}
//               target="_blank"
//               rel="noreferrer"
//               aria-label="Open Aazira Solutions location in Google Maps"
//             >
//               {MAP_ADDRESS}
//             </a>
//           </p>
//         </div>
//       </div>

//       {/* --- Responsive Google Map Embed --- */}
//       {/* <div
//         className="map-wrap"
//         data-aos="zoom-in"
//         aria-label="Map showing Aazira Solutions location"
//       >
//         <iframe
//           className="map-iframe"
//           src={mapEmbedSrc}
//           allowFullScreen
//           loading="lazy"
//           referrerPolicy="no-referrer-when-downgrade"
//           title="Aazira Solutions Location Map"
//         ></iframe>
//       </div> */}
//     </div>
//   );
// };

// export default Contact;

// Contact.js
import React, { useEffect } from "react";
import "./Contact.css";
import AOS from "aos";
import "aos/dist/aos.css";
import { FaPhoneAlt, FaEnvelope, FaMapMarkerAlt } from "react-icons/fa";

const MAP_ADDRESS =
  "Office no. 213-214, Second Floor, City Point, Boat Club Rd, Bund Garden, Sangamvadi, Pune, Maharashtra 411001";

const Contact = () => {
  useEffect(() => {
    AOS.init({ duration: 900, once: true, easing: "ease-out" });
  }, []);

  // // Simple embed URL using your address (works without API key)
  // const mapEmbedSrc = `https://www.google.com/maps?q=${encodeURIComponent(
  //   MAP_ADDRESS
  // )}&output=embed`;

  return (
    <div className="contact-section">
      {/* soft animated background */}
      <div className="c-blob c-blob-1" aria-hidden="true" />
      <div className="c-blob c-blob-2" aria-hidden="true" />

      <h2 className="contact-title" data-aos="fade-up">
        Get in Touch
      </h2>
      <p className="contact-subtitle" data-aos="fade-up" data-aos-delay="80">
        We’d love to hear from you — reach out with your questions or ideas!
      </p>

      <div className="contact-grid">
        {/* Phone */}
        <div className="contact-card" data-aos="zoom-in-up" data-aos-delay="80">
          <span className="shine" aria-hidden="true" />
          <FaPhoneAlt className="contact-icon" />
          <h3>Phone</h3>
          <p className="contact-value">
            <a
              className="contact-link"
              href="tel:+917276445893"
              aria-label="Call Aazira Solutions at +91 7276445893"
            >
              +91 7276445893
            </a>
          </p>
        </div>

        {/* Email */}
        <div className="contact-card" data-aos="zoom-in-up" data-aos-delay="160">
          <span className="shine" aria-hidden="true" />
          <FaEnvelope className="contact-icon" />
          <h3>Email</h3>
          <p className="contact-value">
            <a
              className="contact-link"
              href="mailto:info@aaziratechnologies.com?subject=Inquiry%20from%20Website"
              aria-label="Email contact at Aazira Solutions"
            >
              info@aaziratechnologies.com
            </a>
          </p>
        </div>

        {/* Address */}
        <div className="contact-card" data-aos="zoom-in-up" data-aos-delay="240">
          <span className="shine" aria-hidden="true" />
          <FaMapMarkerAlt className="contact-icon" />
          <h3>Address</h3>
          <p className="contact-value">
            <a
              className="contact-link"
              href={`https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(
                MAP_ADDRESS
              )}`}
              target="_blank"
              rel="noreferrer"
              aria-label="Open Aazira Solutions location in Google Maps"
            >
              {MAP_ADDRESS}
            </a>
          </p>
        </div>
      </div>

      {/* Responsive Google Map Embed (uncomment to show) */}
      {/* <div
        className="map-wrap"
        data-aos="fade-up"
        data-aos-delay="180"
        aria-label="Map showing Aazira Solutions location"
      >
        <iframe
          className="map-iframe"
          src={mapEmbedSrc}
          allowFullScreen
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
          title="Aazira Solutions Location Map"
        ></iframe>
      </div> */}
    </div>
  );
};

export default Contact;
